import {useQuery} from '@tanstack/react-query';
import {GratitudeLeaderType, GratitudeService} from 'client';
import {Layout} from 'components/DSYS/Layout';
import {SkeletonFadeIn} from 'components/DSYS/SkeletonFadeIn';
import {t} from 'i18next';
import {getService} from 'utilities';

import {Gratitude} from './Gratitude';
import {Leaderboard} from './Leaderboard';
import {LeaderboardSkeleton} from './LeaderboardSkeleton';

const gratitudeService = getService(GratitudeService);

export const LeaderboardView = () => {
  const senders = useQuery({
    queryKey: ['home', 'gratitudes', 'leaders', GratitudeLeaderType.SENDER],
    queryFn: () => gratitudeService.getGratitudesSentLeadersApiV1GratitudesLeadersSentGet(),
  });
  const recipients = useQuery({
    queryKey: ['home', 'gratitudes', 'leaders', GratitudeLeaderType.RECIPIENT],
    queryFn: () =>
      gratitudeService.getGratitudeRecipientLeadersApiV1GratitudesLeadersRecipientsGet(),
  });

  return (
    <Layout.Container width="100%">
      <Gratitude title={t('gratitude_leaderboard')}>
        <div>
          <SkeletonFadeIn
            loading={senders.isLoading}
            skeleton={<LeaderboardSkeleton title={t('top_senders')} />}
          >
            <Leaderboard
              title={t('top_senders')}
              data={senders.data}
              leaderType={GratitudeLeaderType.SENDER}
            />
          </SkeletonFadeIn>
          <SkeletonFadeIn
            loading={recipients.isLoading}
            skeleton={<LeaderboardSkeleton title={t('gratitude_leaderboard_recipients')} />}
          >
            <Leaderboard
              title={t('gratitude_leaderboard_recipients')}
              data={recipients.data}
              leaderType={GratitudeLeaderType.RECIPIENT}
            />
          </SkeletonFadeIn>
        </div>
      </Gratitude>
    </Layout.Container>
  );
};
